import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { GetFlexValueSetList } from '@store/NTX/FlexValue/flexValueSetSlice';
import { GetFlexValueSetList } from '../../store/NTX/FlexValue/flexValueSetSlice';
import { useTranslation } from 'react-i18next';

const useGetFlexValueSetList = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const { FlexValueSetList, loading, error } = useSelector(state => state.FlexValueSet);

  useEffect(() => {
    dispatch(GetFlexValueSetList());
  }, [dispatch]);

  // console.log(FlexValueSetList);

 
  const OptionsflexValueSet = FlexValueSetList?.map(item => ({
    value: item.id,
    label: i18n.language === 'ar' ? item.name2 : item.name,
    lookupType: item.lookupType,
    formatType: item.formatType,
    tableId: item.tableId,
    validationType: item.validationType,
    isSystem: item.formatType === 'S'
  }))?.sort((a, b) => {
    if (a.formatType === 'S' && b.formatType !== 'S') return -1;
    if (a.formatType !== 'S' && b.formatType === 'S') return 1;
    return a.formatType.localeCompare(b.formatType); // أو استخدم 0 إذا لا تريد ترتيبًا إضافيًا
  });

  return { loading, error, FlexValueSetList, OptionsflexValueSet };
};

export default useGetFlexValueSetList;
